const requireContext = require.context('@theme-views/layouts', false, /.*\.vue$/)

export const layouts = requireContext
	.keys()
	.map(file => [file.replace(/(^.\/)|(\.vue$)/g, ''), requireContext(file)])
	.reduce((components, [name, component]) => {
		components[name] = component.default || component
		return components
	}, {})